export interface Currency {
    code: string;
    sign: string;
    is_preferred: boolean;
    name: string;
}
